// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Component } from '@angular/core';
import { LoadingService } from '../../services/loading.service';
import { Observable } from 'rxjs';
import { AnimationOptions } from "ngx-lottie";

@Component({
  selector: 'app-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.css'],
  standalone: false
})
export class LoadingOverlayComponent {
  isLoading$!: Observable<boolean>;
  animationOptions: AnimationOptions = {
    path: 'assets/lotteFiles/Animated-Heart-Fill.json',
    autoplay: true,
    loop: true
  };
  constructor(private loadingService: LoadingService) { }

  ngOnInit(): void {
    // Initialize service properly
    this.isLoading$ = this.loadingService.isLoading$;


  }
}
